module.exports = __webpack_public_path__ + "static/media/S2N1-1.902df9ca.svg";